import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { FractionationChannel, FractionationPrincipalRoutes, FractionationRoute } from 'src/app/models/Fractionation';
import { PaginatedResult } from './../model/paginated-result';

@Injectable({
  providedIn: 'root',
})
export class FractionationService {
  constructor(private http: HttpClient) {}

  /**
   * Todas as rotas, sem paginação. `channel` (RCS, 17tm466frtx) filtra por canal;
   * sem ele o backend devolve as de SMS, que é o default para não mudar quem já
   * chamava. (A URL antiga tinha um `}` sobrando no fim; o backend só olha se o
   * parâmetro veio, então tirar não muda a resposta.)
   */
  getRoutes(page: number, perPage: number, channel?: FractionationChannel): Observable<FractionationRoute[]> {
    let params = new HttpParams().set('no-paginate', 'true');

    if (channel) {
      params = params.set('channel', channel);
    }

    return this.http.get<FractionationRoute[]>(`${environment.apiUrl}/fractionations`, { params });
  }

  listPaginated(
    page: number,
    perPage: number,
    routeName: string = '',
    channel?: FractionationChannel
  ): Observable<PaginatedResult<FractionationRoute[]>> {
    const channelParam = channel ? `&channel=${channel}` : '';

    return this.http.get<PaginatedResult<FractionationRoute[]>>(
      `${environment.apiUrl}/fractionations?page=${page}&per_page=${perPage}&route_name=${encodeURIComponent(routeName)}${channelParam}`
    );
  }

  addRoute(route: FractionationRoute): Observable<FractionationRoute> {
    return this.http.post<FractionationRoute>(
      `${environment.apiUrl}/fractionations`,
      route
    );
  }

  changeGroupActive(route: FractionationRoute): Observable<void> {
    return this.http.put<void>(
      `${environment.apiUrl}/fractionations/changeGroupActive/${route.id}`,
      {
        active: route.active,
      }
    );
  }

  turnMonitoredRoute(route: FractionationRoute): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/fractionations/set-monitored/${route.id}`, {});
  }

  turnDefaultRoute(route: FractionationRoute): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/fractionations/set-default/${route.id}`, {});
  }

  turnPixRoute(route: FractionationRoute): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/fractionations/set-pix/${route.id}`, {});
  }

  getRoute(id: string): Observable<FractionationRoute> {
    return this.http.get<FractionationRoute>(
      `${environment.apiUrl}/fractionations/${id}`
    );
  }

  getPrincipalRoutes(): Observable<FractionationPrincipalRoutes> {
    return this.http.get<FractionationPrincipalRoutes>(
      `${environment.apiUrl}/fractionations/principal-routes`
    );
  }

  updateRoute(id: string, route: FractionationRoute): Observable<FractionationRoute> {
    return this.http.put<FractionationRoute>(
      `${environment.apiUrl}/fractionations/${id}`,
      {name: route}
    );
  }
}
